import {ChevronDownIcon} from "@pg-design/icons-module";

import * as styles from "./NavigationDropdownIndicator.module.css";

interface IProps {
    showDropdown?: boolean;
}

export const NavigationDropdownIndicator = (props: IProps) => {
    return (
        <span className={`dropdown-indicator ${props.showDropdown ? styles.indicatorVisible : styles.indicatorHidden}`}>
            <ChevronDownIcon size="1" wrapperSize="1.6" wrapperColor="#fff" wrapperType="square" />
        </span>
    );
};
import {ChevronDownIcon} from "@pg-design/icons-module";

import * as styles from "./NavigationDropdownIndicator.module.css";

interface IProps {
    showDropdown?: boolean;
}

export const NavigationDropdownIndicator = (props: IProps) => {
    return (
        <span className={`dropdown-indicator ${props.showDropdown ? styles.indicatorVisible : styles.indicatorHidden}`}>
            <ChevronDownIcon size="1" wrapperSize="1.6" wrapperColor="#fff" wrapperType="square" />
        </span>
    );
};
